import React, { useState, useContext } from 'react';
import { LegacyStack, Tabs, Collapsible, Link } from '@shopify/polaris';
import OrdersTable from './OrdersTable'
import InstructorCoursesTable from './InstructorCoursesTable'
import StudentsTable from './StudentsTable'
import SubscriptionsTable from './SubscriptionsTable'
import SubscriptionRow from './SubscriptionRow'
import OfficeHourRow from './OfficeHourRow'
import OfficeHoursTable from './OfficeHoursTable'
import RegistrationRow from './RegistrationRow'
import EditRegisterRelated from './EditRegisterRelated'
import Details from './Details'
import {Util, useReducerTab} from '@thinkwell/react.common'
import AccountModel from '../../models/Account'
import OfficeHourable from '../../concerns/OfficeHourable'
import Extendable from '../../concerns/Extendable'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { OfficeHourSubscriptionsContext } from '../../contexts/OfficeHourSubscriptions'
import { RegistrationsContext } from '../../contexts/Registrations'
import { SectionsProvider } from '../../contexts/Sections'
import { LineItemsExtensionContext } from '../../contexts/LineItemsExtension'
import { UserContext } from '../../contexts/User'
import Iframe from 'react-iframe'

export default function Account(props) {
  Util.hideLoader()

  const customerPortalFrame = document.querySelector('#paywhirl-customer-portal-frame')
  const src = customerPortalFrame && customerPortalFrame.src

  const lineItemsExtension = useContext(LineItemsExtensionContext);
  const subscriptions = useContext(SubscriptionsContext);
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext);
  const registrations = useContext(RegistrationsContext);
  const user = useContext(UserContext);
  const account = AccountModel(subscriptions, officeHourSubscriptions, registrations, lineItemsExtension, user)

  const [previousCoursesActive, setPreviousCoursesActive] = useState(false);

  const tabs = [
    {
      id: 'courses',
      content: 'Courses'
    },
    {
      id: 'orders',
      content: 'Orders'
    },
    {
      id: 'account',
      content: 'Account'
    }
  ];

  if (src) {
    tabs.push({
      id: 'subscriptions',
      content: 'Subscriptions'
    })
  }

  if (account.studentCourses.length) {
    tabs.splice(1, 0, {id: 'students', content: 'Students'})
  }

  const [state, onTabSelected] = useReducerTab(props, tabs)

  const coursesEl = (
    <div>
      { OfficeHourable.unassigned(officeHourSubscriptions, subscriptions, lineItemsExtension).length > 0 ? <OfficeHoursTable /> : null }

      { account.hasInstructorCourses ? <InstructorCoursesTable /> : null }

      <SubscriptionsTable titleHidden={account.myCoursesTitle_flags.length}
      title={account.myCoursesTitle_flags.length ? account.myCoursesTitle_flags : 'My Courses'}
      filter={account.myCoursesFilter}>
        {
          account.relatedRegisterableSubscriptions.length && !account.teacherEnrollment ?
          (<SectionsProvider><EditRegisterRelated
            id={account.relatedRegisterableSubscriptions.map((s) => s.enrollmentId).join(',')}
            sections={props.sections} /></SectionsProvider>
          ) : null
        }
      </SubscriptionsTable>

      <SubscriptionsTable titleHidden={account.myStudentCoursesTitle_flags.length}
      title={account.myStudentCoursesTitle_flags.length ? account.myStudentCoursesTitle_flags : 'My Students Courses'}
      filter={account.myStudentCoursesFilter} />

      { !account.hasCourses ? <span>You do not have any courses yet.</span> : null}

      {
        account.previousCourses.length || account.previousOfficeHourSubscriptions.length ?
        <div>
          <br/><br/>
          <Link onClick={() => setPreviousCoursesActive(!previousCoursesActive)}><h2>Previous Subscriptions</h2></Link>
          <Collapsible open={previousCoursesActive}>
              <table className="responsive subscriptions"><tbody>
              { account.previousCourses.map((subscription) => {
                  return <SubscriptionRow id={subscription.id} key={`${subscription.id}-${subscription.quantity_index || '0'}`} />
                })
              }
              { account.previousOfficeHourSubscriptions.map((officeHourSubscription) => {
                  return <OfficeHourRow id={officeHourSubscription.id} key={officeHourSubscription.id} />
                })
              }
              </tbody>
              </table>
          </Collapsible>
        </div> : null
      }
    </div>
  )

  const studentsEl = (<StudentsTable />)

  const ordersEl = (
    <OrdersTable />
  )

  const accountEl = (
    <Details />
  )

  return (<Tabs tabs={tabs} selected={state.tabIndexSelected} onSelect={onTabSelected} fitted>
      { state.tabSelected == 'courses' ? coursesEl : null }
      { state.tabSelected == 'students' ? studentsEl : null }
      { state.tabSelected == 'orders' ? ordersEl : null }
      { state.tabSelected == 'account' ? accountEl : null }
      { state.tabSelected == 'subscriptions' ? <Iframe url={src} width="100%" height="400px" /> : null }
    </Tabs>)
}
